module.exports = __webpack_public_path__ + "assets/images/outfit-03.7ff48900f1f09b607148496845139c96.svg";